import { Component, Input, OnInit } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { createControl } from "../../../create-request/utilities/formUtilities";
import { Constants } from "../../../shared/utilities/Constants";

@Component({
  standalone: false,
    selector: 'mm-sa-bundled-toggle',
    templateUrl: './sa-bundled-toggle-component.html',
    styleUrls: ['./sa-bundled-toggle-component.scss']
})
export class SaBundledToggleComponent implements OnInit {
    @Input()
    parentForm: FormGroup;

    bundledMessage: string = Constants.createBundledSaMessaging;

    ngOnInit(): void {
        createControl(this.parentForm, 'isSubmitAndCreateBundledSa', false, undefined, undefined, undefined)
    }

    ngOnDestroy(): void {
        this.parentForm.removeControl('isSubmitAndCreateBundledSa');
    }

    get checked(): boolean {
        return this.parentForm.controls.isSubmitAndCreateBundledSa.value;
    }

    /**
   *
   * @param toggleValue Boolean value from the toggle switch. true = checked/Yes, false = unchecked/No
   *
   */
    onToggleChange(toggleValue: Event) {
        const e = toggleValue as CustomEvent<boolean>;
        this.parentForm.controls.isSubmitAndCreateBundledSa.setValue(e.detail);
    }

    onChangeToggle(toggleValue: boolean) {
        this.parentForm.controls.isSubmitAndCreateBundledSa.setValue(toggleValue);
    }
}